import classNames from 'classnames'
import ReactInputMask from 'react-input-mask'

import { type ICommonField } from '@/app/types/common'
import { type InputEvent } from '@/pages/Dms/helper'

import style from './TelephoneField.module.scss'

interface IProps {
    entity: ICommonField
    onChange: (e: InputEvent) => void
    className?: string
    onSetIsTouched: () => void
    disabled?: boolean
}

export const TelephoneField = (props: IProps) => {
    const { entity, onChange, className, disabled, onSetIsTouched } = props
    const { name, value, error, isTouched, placeholder } = entity
    const isError = isTouched && !!error
    return (
        <div className={classNames(style.container, className && className)}>
            <div className={style.blockTitle}>
                <span>{name}</span>
            </div>
            <div className={style.inputWrapper}>
                <ReactInputMask
                    className={classNames(style.field, isError && style.fieldError)}
                    maskChar={null}
                    name={name}
                    type='tel'
                    value={value || ''}
                    onChange={onChange}
                    mask={'+7 (999) 999-99-99'}
                    onFocus={onSetIsTouched}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}
